import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import externalAuthService from 'services/api/authentication/externalAuth';
import Actions from 'Actions';
import UrlUtils from 'utils/Url';
import RegisterEN from 'components/Register/locales/Register_en_US';
import RegisterFR from 'components/Register/locales/Register_fr_CA';
import localeUtils from 'utils/LanguageLocale';
const getText = localeUtils.getLocalisedDataFromResource(RegisterEN, RegisterFR);

export const handleGrant = async (sessionId, setErrorMessages, dispatch) => {
    dispatch(Actions.showInterstice(true));
    setErrorMessages([]);

    try {
        const approved = true;
        const response = await externalAuthService.submitGrant(sessionId, approved);

        if (response.redirectUrl) {
            Storage.local.removeItem(LOCAL_STORAGE.EXTERNAL_AUTH_PARAMS);
            UrlUtils.redirectTo(response.redirectUrl);
        } else {
            throw { errorMessage: getText('authorizationFailed') };
        }
    } catch (error) {
        // Handle 403 responses and error structure: {error: "invalid_session", errorDescription: "Session ID mismatch"}
        const errorMessage =
            error?.errorDescription || error?.error_description || error?.errorMessage || error?.message || getText('authorizationFailed');

        setErrorMessages([errorMessage]);
    } finally {
        dispatch(Actions.showInterstice(false));
    }
};

export const extractOAuth2Params = () => {
    const urlParams = new URLSearchParams(window.location.search);

    return {
        responseType: urlParams.get('response_type') || '',
        clientId: urlParams.get('client_id') || '',
        redirectUri: urlParams.get('redirect_uri') || '',
        scope: urlParams.get('scope') || '',
        state: urlParams.get('state') || '',
        codeChallenge: urlParams.get('code_challenge') || '',
        codeChallengeMethod: urlParams.get('code_challenge_method') || '',
        nonce: urlParams.get('nonce') || '',
        prompt: urlParams.get('prompt') || '',
        display: urlParams.get('display') || '',
        maxAge: urlParams.get('max_age') || '',
        uiLocales: urlParams.get('ui_locales') || '',
        idTokenHint: urlParams.get('id_token_hint') || '',
        loginHint: urlParams.get('login_hint') || '',
        acrValues: urlParams.get('acr_values') || ''
    };
};

export const checkIsOAuth2Flow = params => {
    return !!(params.clientId && params.redirectUri);
};

export const storeOAuth2Params = params => {
    if (checkIsOAuth2Flow(params)) {
        Storage.local.setItem(LOCAL_STORAGE.EXTERNAL_AUTH_PARAMS, params);
    }
};
